import { useEffect, useState } from "react";
import { Loader, Stack, Text } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useNavigate, useSearchParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { SmsType } from "@/models/club";
import useStore from "@/store/discount";
import { useSmartAudiences } from "@/services/smartAudience/hooks";
import CampaignPage, { CampaignActions } from "@/modules/marketing/CampaignPage";
import TemplatePicker, { useMessageParts } from "@/modules/marketing/TemplatePicker";
export default function DiscountSelectMessage() {
  const store = useStore();
  const [selected, setSelected] = useState(store.smsTemplate);
  const navigate = useNavigate();
  const parts = useMessageParts(selected?.text);
  // An opportunity's «پیامک با کد تخفیف» lands here as ?audience=<key>[&member=<id>]: the audience is
  // already decided, so it is set and the text step shows straight away.
  const [params, setParams] = useSearchParams();
  const audienceKey = params.get("audience");
  const member = Number(params.get("member")) || undefined;
  const audiences = useSmartAudiences({ merchantUserId: member, enabled: Boolean(audienceKey) });
  useEffect(() => {
    if (!audienceKey || audiences.isLoading) return;
    const audience = audiences.data?.find((item) => item.key === audienceKey);
    setParams({}, { replace: true });
    if (!audience) {
      notifications.show({ color: "yellow", message: audiences.isError ? "پیشنهاد دریافت نشد. دوباره تلاش کنید." : "این پیشنهاد دیگر مخاطبی ندارد." });
      navigate("/dashboard/discount/selectGroup", { replace: true });
      return;
    }
    store.clearDiscount();
    store.setSmartAudience({ id: uuidv4(), smartAudience: { ...audience, merchantUserId: member } });
    setSelected(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audienceKey, audiences.isLoading, audiences.data, audiences.isError]);
  const next = () => { if (!selected?.id) return; store.setSmsTemplate({smsTemplate:selected}); navigate("/dashboard/discount/selectDiscountType"); };
  if (audienceKey) return <Stack align="center" justify="center" mih={240} gap="sm"><Loader color="violet" /><Text size="sm" c="dimmed">در حال آماده کردن مخاطبان…</Text></Stack>;
  return <CampaignPage flow="discount" step={1} title="متنی انتخاب کنید که دیده شود" description="متن مناسب را انتخاب کنید و پیش‌نمایش آن را قبل از ادامه ببینید." previewText={selected?.text ?? ""} mobilePreview={false} actions={<CampaignActions back="/dashboard/discount/selectGroup" next="ادامه" onNext={next} disabled={!selected?.id} hint={selected ? `متن: ${selected.title}` : "یک متن برای پیامک انتخاب کنید"} meta={parts} />}>
    <TemplatePicker smsType={SmsType.Value1} value={selected} onChange={setSelected} />
  </CampaignPage>;
}
